export default function getDateObj(value ?: string){
    //value =yyyy-mm-dd
    if(value){
        return new Date(value);
    }
    return new Date();
}